<template>
  <div class="shopCar">
    <div class="shopCarTop">
      <div style="margin-top: 15px" class="shopCarTopSearch">
        <p class="shopCarText">购物车</p>
        <el-input
          placeholder="请输入内容"
          v-model="goodsName"
          class="input-with-select"
        >
          <el-button slot="append" @click="getShopCarList"> 搜索</el-button>
        </el-input>
      </div>
      <p class="shopNum">
        全部商品
        <span>{{ goodsNum }}</span>
      </p>
    </div>
    <div class="shopCarTab">
      <div class="shopCarTab_t shopCarTab_t2">
        <p class="checkout">
          <el-checkbox-group
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
          ><el-checkbox>全选</el-checkbox>
          </el-checkbox-group>
        </p>
        <p class="name">商品</p>
        <p class="specifications">规格</p>
        <p class="money">单价</p>
        <p class="number">数量</p>
        <p class="xiao">小计</p>
        <p class="operation">操作</p>
      </div>
      <div v-for="(item,index) in shopUserList" :key="index">
        <div class="shopCarTab_t shopCarTab_com">
          <p class="checkout_com">
              <el-checkbox
                v-model="item.checked"
                @change="handleCheckedCities2(index,item.checked)"
              ></el-checkbox><span style="margin-left: 2%;cursor: pointer;" @click="goToDetail(item.enterPriseUuid)">{{ item.storeName }}</span>
            <i class="iconfont" @click="startChat(item.shopUserUuid)">&#xe660;</i>
          </p>
        </div>
        <div
          class="shopCarTab_t shopCarTab_com shopCarTab_comTop"
          v-for="(chilItem,chilIndex) in item.shopCarList" :key="chilIndex">
          <p class="checkout_mess">
            <el-checkbox-group
              v-model="chilItem.checked"
              @change="handleCheckedCities_child(index,chilIndex,chilItem.checked)"
            >
              <el-checkbox></el-checkbox>
            </el-checkbox-group>
          </p>
          <div class="name_mess" style="cursor: pointer;" @click="handGoodsDetails(chilItem.goodsUuid)">
            <div style="width:100px;height:64px;margin-right:10px">
                <img :src="chilItem.specUrl" alt="" style="width:100px;height:64px">
            </div>
            <div class="flex brandBox">
              <p class="brand" v-if="chilItem.brand">{{ chilItem.brand }}</p>
              <span>{{chilItem.goodsName}}</span>
            </div>
          </div>
          <p class="specifications">{{chilItem.specName}}</p>
          <p class="money">¥{{chilItem.price}}</p>
          <p class="number">
            <el-input-number
                v-model="chilItem.num"
                @change="handleChange1(chilItem)"
                :min="1"
                :max="chilItem.specNum-chilItem.soldAmount>200?200:chilItem.specNum-chilItem.soldAmount"
                label="描述文字"
            ></el-input-number>
          </p>
          <p class="xiao">¥{{Number(chilItem.price*chilItem.num).toFixed(2)}}</p>
          <p class="operation">
            <el-button type="text" @click="deleteGood(chilItem)">删除</el-button>
          </p>
        </div>
      </div>
    </div>
    <!-- 合计 -->
    <div class="combined">
      <div class="combined_left">
        <p class="checkout">
          <el-checkbox-group
                  :indeterminate="isIndeterminate"
                  v-model="checkAll"
                  @change="handleCheckAllChange"
          ><el-checkbox>全选</el-checkbox>
          </el-checkbox-group>
        </p>
        <p class="combined_left_del" @click="deleteCheckedGood">删除选中的商品</p>
      </div>
      <div class="combined_right">
        <p class="combined_right_ok">已选中 <span>{{ totalNum }}</span> 件商品 <i class="el-icon-arrow-up"></i></p>
        <p class="combined_right_money">总价：<span>¥{{ totalPrice }}</span></p>
        <p class="combined_right_button" @click="submitOrder">提交订单</p>
      </div>

    </div>
    <!--聊天窗口-->
    <chat-dialog ref="chatDialogRef"></chat-dialog>
  </div>
</template>

<script>
import chatDialog from "../chat/chatDialog";
import { getShopCarList,getUserInfo,getShopCarNumber,saveShopCarNum,
  getNewcurrent,deleteShopCarInfo } from '../../utils/interface';
import {mapState, mapMutations} from "vuex";
export default {
  //   水泵云商购物车
  name: "shopCar",
  components: {chatDialog},
  computed: {
    ...mapState({
      isLogin: "isLogin",
      isUsermessage: "isUsermessage"
    }),
  },
  data() {
    return {
      goodsName: "",
      shopUserList: [],
      checkAll: false,
      isIndeterminate: true,
      checkChildList: [],
      goodsNum:0,
      userMessages: {},
      totalPrice:0,
      totalNum:0,
    };
  },
  created(){
    this.getShopCarList();
    getNewcurrent().then((res) => {
      this.userMessages = res;
    })
    .catch((err) => {
      console.log(err);
    });
  },
    mounted(){
      if (this.isLogin == false) {
        this.$router.push('/mall');
      }
    },
  methods: {
    ...mapMutations(["isLoginVuex"]),
    startChat(targetUserId) {
      if (this.isLogin) {
        let user = this.$store.state.isUsermessage;
        if (targetUserId == this.userMessages.uuid) {
          this.$message.error('检测当前联系店铺与您处于同一企业，暂不支持联系!');
          return false;
        } else {
          getUserInfo(targetUserId).then(res => {
            this.$refs.chatDialogRef.init(user.uuid, user.name, user.headUrl, targetUserId, res.name, res.headUrl);
          });
        }
      } else {
        this.$message({
          type: "success",
          message: "您需要先登录哦！",
        });
        this.$router.push('/login')
      }
    },
    getShopCarList(){
      getShopCarNumber().then((res)=>{
        if(res.success) {
          this.goodsNum = res.data;
        }
      })
      let params = {
        goodsName:this.goodsName,
      }
      getShopCarList(params).then((res)=>{
        res.map(item=>{
          item.checked = false;
          item.shopCarList.map(childItem => {
            childItem.checked = false;
          })
        });
        this.shopUserList = res;
        this.getCheckInfo();
        this.handleChange();
      });
    },
    handleCheckAllChange() {
      this.totalNum = 0;
      this.totalPrice = 0;
      this.shopUserList.map(item=>{
        item.checked = this.checkAll;
        item.shopCarList.map(childItem => {
          childItem.checked = this.checkAll;
          // 计算商品数量
          // 计算总价
          if(childItem.checked) {
            this.totalNum++;
            this.totalPrice = Number(this.totalPrice) + Number(Number(childItem.num)*Number(childItem.price));
            this.totalPrice = Number(this.totalPrice).toFixed(2);
          }
        })
      });
    },
    handleCheckedCities2(index,val){
      this.shopUserList[index].shopCarList.map(items=>{
        items.checked = val
      });
      this.handleChange();
      this.getCheckInfo();
    },
    handleCheckedCities_child(index,childIndex,val){
      this.shopUserList[index].shopCarList[childIndex].checked = val;
      this.handleChange();
      this.getCheckInfo();
    },
    // 是否全部选中
    getCheckInfo(){
      let parent_check = 0;
      this.shopUserList.map(item=>{
        let child_check = 0;
        item.shopCarList.map(child=>{
          if(child.checked){
            child_check++;
          }
          if(child_check === item.shopCarList.length){
            item.checked=true;
            parent_check++
          }else{
            item.checked=false;
          }
        });
      });
      if(parent_check === this.shopUserList.length){
        this.checkAll = true;
      }else{
        this.checkAll = false;
      }
    },
    handleChange() {
      this.totalNum = 0;
      this.totalPrice = 0;
      let count = 0;
      let amount = 0;
      this.shopUserList.map(item=>{
        item.shopCarList.map(childItem => {
          if (childItem.checked) {
            count++;
            amount = Number(amount) + Number(Number(childItem.num) * Number(childItem.price));
            amount = Number(amount).toFixed(2);
          }
        })
      });
      this.totalNum = count;
      this.totalPrice = amount;
    },
    handleChange1(item) {
      // 保存购物车数量
      saveShopCarNum({uuid:item.uuid,num:item.num});
      this.handleChange();
    },
    deleteGood(item){
      // 删除数据
      deleteShopCarInfo({shopCarUuid:item.uuid}).then((res)=>{
        if(res.success){
          this.$message.success("删除成功");
          this.getShopCarList();
        }
      });
    },
    deleteCheckedGood(){
      this.shopUserList.map(item=>{
        item.shopCarList.map(childItem => {
          if (childItem.checked) {
            deleteShopCarInfo({shopCarUuid:childItem.uuid}).then((res)=>{
              if(res.success){
                //this.$message.success("删除成功");
                this.getShopCarList();
              }
            });
          }
        })
      });
    },
    submitOrder(){
      // if(this.userMessages.identity === "ANONYMOUS"){
      //   this.$confirm('请先进行实名认证!', '提示', {
      //     confirmButtonText: '去认证',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     this.$router.push('/userCenter/10');
      //   });
      //   return false;
      // }
      let updateForm = [];
      let updateFormInfo = {};
      this.shopUserList.map(item=>{
        item.shopCarList.map(childItem => {
          if (childItem.checked) {
            updateFormInfo = {
              goodsUuid:childItem.goodsUuid,
              goodsNum:childItem.num,
              goodsSpecUuid:childItem.goodsSpecUuid
            }
            updateForm.push(updateFormInfo);
          }
        })
      });
      if(updateForm.length === 0) {
        this.$message.error("请选择商品");
        return false;
      }
      // 数据完成之后跳转页面
      window.sessionStorage.removeItem("updateForm");
      window.sessionStorage.setItem("updateForm",JSON.stringify(updateForm));
      let routeData = this.$router.resolve({
        name: "shopAffirmOrder",
      });
      window.open(routeData.href, "_blank");
    },
    goToDetail(enterpriseUuid){
      let routeData = this.$router.resolve({
        name: "printServiceIndex",
        params: {enterPriseId: enterpriseUuid},
      });
      window.open(routeData.href, "_blank");
    },
    handGoodsDetails(uuid) {
      let routeData = this.$router.resolve({
        name: "shopGoodDetails",
        params: { uuid: uuid },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style scoped lang="less">
.shopCar {
  .shopCarTop {
    width: 1200px;
    margin: 0 auto;
    .shopCarTopSearch {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .shopCarText {
        flex-shrink: 0;
        font-size: 20px;
        color: #009999;
        font-weight: 600;
      }
      .input-with-select .el-input-group__prepend {
        border: 1px solid #009999;
        background-color: #009999;
      }
      /deep/.el-input-group {
        width: 30%;
      }
      /deep/.el-input__inner {
        height: 33px;
        line-height: 33px;
        border: 1px solid #009999;
      }
      /deep/.el-input-group__append,
      .el-input-group__prepend {
        border: 1px solid #009999;
        background-color: #009999;
      }
      /deep/.el-button {
        color: #fff;
      }
    }
    .shopNum {
      margin: 40px 0 10px;
      color: #009999;
      cursor: pointer;
      font-family: tahoma, arial, Microsoft YaHei, Hiragino Sans GB;
    }
  }
  .shopCarTab {
    width: 1200px;
    margin: 0 auto;
    min-height: 600px;
    .shopCarTab_t {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding: 10px;
      text-align: center;
      .checkout {
          width: 44px;
      }
      .name {
          width: 250px;
      }
      .name_mess {
          width: 250px;
          text-align: left;
          display: flex;
          font-size: 13px;
          display: flex;
          align-items: center;
          img {
              margin-right: 5px;
              width: 100px;
              height: 64px;
          }
      }
      .specifications {
          width: 133px;
      }
      .money {
          width: 133px;
      }
      .number {
          width: 133px;
      }
      .xiao {
          width: 143px;
      }
      .operation {
          width: 120px;
      }
      .checkout_mess {
          width: 44px;
          text-align: left;
      }
    }
    .shopCarTab_t2 {
      background: #efefef;
    }
    .shopCarTab_com {
        border-bottom: 1px solid #efefef;
        .number {
            /deep/.el-input__inner {
                height: 28px;
                line-height: 28px;
            }
            /deep/.el-input-number__decrease, .el-input-number__increase {
                height: 25px;
                line-height: 25px;
                top: 7px;
            }
            /deep/.el-input-number__increase {
                height: 25px;
                line-height: 25px;
                top: 7px;
            }
            /deep/.el-input-number {
              width: 134px;
            }
        }
        .checkout_com {
          width: 25%;
          color: #009999;
          display: flex;
          align-items: center;
          i {
            cursor: pointer;
            font-size: 18px;
            margin-left: 10px;
          }
        }
    }
    .shopCarTab_comTop {
      padding: 15px 0;
      .name_mess {
        span {
          line-height: 22px;
          letter-spacing: 1px
        }
      }
      .checkout_mess {
        margin-left: 10px;
      }
      .specifications {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .xiao {
        font-weight: 700;
      }

    }
  }
  .combined {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1200px;
    margin: 0 auto 20px;
    font-size: 14px;
    color: #666;
    // border: 1px solid #efefef;
    // padding: 20px ;
    .combined_left {
      display: flex;
      align-items: center;
      .combined_left_del {
        margin-left: 15px;
        cursor: pointer;
      }
    }
    .combined_right {
      display: flex;
      align-items: center;
      .combined_right_ok {
        margin-right: 10px;
        i {
          cursor: pointer;
        }
      }
      .combined_right_money {
        margin-right: 15px;
        display: flex;
        align-items: center;
        span {
          font-size: 25px;
          font-weight: 600;
          color: #009999;
        }
      }
      .combined_right_button {
        width: 100px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: #009999;
        color: #fff;
        cursor: pointer;
        font-size: 18px;

      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/threeShop/shopCar.vue